module.exports = __webpack_public_path__ + "img/file-plus-03.7dcb4186.svg";